<template>
  <div>

    <div class="d-flex flex-row align-items-center mb-3">
      <h5 v-if="showTitle" class="mb-0 mr-2 d-flex align-items-center">
        <i v-if="icon" :class="[icon, 'mr-1', 'fa-lg']"></i>
        {{$t(`resources.block_titles.${service}`)}}
      </h5>
      <b-button
        size="sm"
        @click="toggleServiceStatus"
        :variant="connected_status  ? 'outline-secondary' : 'secondary'"
      >
        {{ connected_status ? $t('button.disconnect') : $t('button.connect')}}
      </b-button>
      <b-button
        size="sm"
        class="ml-2"
        variant="outline-secondary"
        @click="synchronizeData"
      >
        {{$t('button.synchronize')}}
      </b-button>
    </div>

    <div class="align-items-end mb-3">

        <p class="mb-0">{{$t('form.status')}}:
          <span v-if="connected_status" class="text-success">{{$t('resources.connected')}}</span>
          <span v-else class="text-muted">{{$t('resources.not_connected')}}</span>
        </p>

    </div>

    <campaignMonitorClients :synchronize="synchronize" v-if="resources_key && connected_status" :resources_key="resources_key"/>

  </div>
</template>

<script>
  import axios from "@/utils/axios";
  import campaignMonitorClients from './campaignMonitorClients';

  export default {
    name: "ServiceConnect",
    props: {
      service: {
        type: String,
        required: true
      },
      connected: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      showTitle: {
        type: Boolean,
        default: false
      },
      resources_key: {
        type: String
      }
    },
    components: {
      campaignMonitorClients
    },
    data() {
      return {
        access_token: null,
        reset_params: {
          settings: {}
        },
        connected_status: false,
        url: `${window.location.origin}${window.location.pathname}`,
        synchronize: false
      }
    },
    computed: {
      code() {
        return this.$route.query.code
      },
    },
    created() {
      this.connected_status = this.connected;

      if (this.code) {
        this.sendToken()
      }
      if (this.connected_status) {
        this.$set(this.reset_params.settings, this.service, {
          oauth: {
            access_token: '',
            refresh_token: ''
          }
        });
      }
    },
    methods: {
      toggleServiceStatus() {
        if (this.connected_status) {
          this.putData(`resources/${this.resources_key}`, this.reset_params).then(resp => {
            if (resp && resp.data) {
              this.connected_status = false;
            }
          })
        } else {
          console.log(this.url, 'this.url');
          axios.get(`admin/integrations/${this.service}/oauth?auth_redirect_url=${this.url}&resource=${this.resources_key}`).then(resp => {

            if (resp && resp.data) {

              console.log('resp.data', resp.data);
              console.log(decodeURIComponent(resp.data.authorize_url));
              window.location = decodeURIComponent(resp.data.authorize_url);
            }


          })
        }
      },
      sendToken() {
        axios.post(`admin/integrations/${this.service}/oauth`, {code: encodeURIComponent(this.code)}).then(resp => {
          if (resp && resp.data) {
            this.$router.push({path: this.$route.path, query: {resource: this.$route.query.resource}});
            this.connected_status = true;
          }
        }).catch((e) => {
          console.log('sendToken error', e);
          this.$router.push({path: this.$route.path, query: {resource: this.$route.query.resource}})
        })
      },
      synchronizeData() {
        this.synchronize = !this.synchronize;
        this.$forceUpdate();
      }
    }
  }
</script>
